/**
 * Editable partner details table to be shown on registration
 */

import { Button, Form } from "react-bootstrap";
import DataTable from "../../common/components/DataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../template/store";
import { useDispatch } from "react-redux";
import { useState, useEffect, useMemo } from "react";
import { fetchLinerNameByCountry } from "../registration/actions/Registration";
import { addPartnerTableRow, removePartnerTableRow, setPartnerTableCols, setPartnerTableRow, updateLinerOptions } from "./CustomerCodeSlice";
import UploadThing from "../../../components/common/UploadThing";
import InfoDiv from "../../../components/common/InfoDiv";
// restriction config with regex
const LinerConfig = { "24118": /[^A-Za-z0-9]/g }

export default function CustomerCodeRequestTable({ country, isDataTableDisabled, isFileUploading }: any,) {

    const { t } = useTranslation()
    const data = useSelector((state: RootState) => state.customerCodeRequest.partnerTable)
    const dispatch = useDispatch<AppDispatch>()

    const linerOptions = useSelector(
        (state: RootState) => state.customerCodeRequest.linerOptions
    );
    const selectedLinerValues = data ? data?.map((row: any) => row.liner) : [];
    const codeManualLiners = useMemo(() => [1, '1'], [])

    useEffect(() => {
        if (country) dispatch(fetchLinerNameByCountry({ country_code: country })).unwrap().then((d) => {
            // dispatch(updateLinerOptions(d || [{ text: "Hapag-Lloyd", value: 1 }]))
            const options = Array.isArray(d) ? d : [];

            dispatch(updateLinerOptions(d || [{ text: "", value: 0 }]))

            if (!isDataTableDisabled) {
                const firstOption = d.length > 0 ? d[0].value : 1
                dispatch(setPartnerTableCols(
                    {
                        liner: firstOption,
                        m: true
                    }
                ))

            }

        }).catch(() => {
            // unwrap can throw if thunk returns {}
            dispatch(updateLinerOptions([{ text: "", value: 0 }]));
        });
    }, [country])

    const tableColumnConfig = [
        {
            accessor: 'rowNumber',
            Header: 'rowNumber',
        },
        {
            accessor: 'liner',
            Header: t('resource_1:liner'),
            width: 180,
            minWidth: 180,
            maxWidth: 200,
            Cell: (rowData: any) => {
                const { rowNumber, liner

                } = rowData.row.original;

                return (
                    <Form.Select
                        value={liner || ''}
                        className={`fs--1 form-control  form-select`}
                        disabled={(linerOptions?.length ?? 0) < 2 || isDataTableDisabled || isFileUploading}
                        onChange={(e) => {
                            const value = e.target.value
                            // if (!isDataTableDisabled ) {
                                dispatch(setPartnerTableRow(
                                    {
                                        rowNumber,
                                        liner: value,
                                        customerCode: "",
                                        attachmentName: "",
                                        serverName: null,
                                        serverPath: null,
                                        loading: 0,
                                        error: {
                                            attachment: false,
                                            customerCode: false,
                                        },
                                        m: true,
                                        customerCodeErrorMessage: ""
                                    }
                                ))

                            // }
                            // else {
                            //     dispatch(setPartnerTableRow(
                            //         {
                            //             rowNumber,
                            //             liner: e.target.value,
                            //         }
                            //     ))
                            // }
                        }}
                    >
                        {linerOptions?.map((i: any) => <option value={`${i.value}`}>{i.text}</option>)}
                        {linerOptions?.length == 0 && <option>no liners</option>}

                    </Form.Select>
                );
            },
        },
        {
            accessor: 'customerCode',
            Header: t('resource_2:customerCode'),
            width: 240,
            minWidth: 240,
            maxWidth: 260,
            Cell: (rowData: any) => {
                const { customerCode, rowNumber, error, liner, customerCodeErrorMessage } = rowData.row.original;

                console.log(rowData.row.original, "customer code table")

                // wrapper to manage code manual link
                const Wrapper = ({ children }: any) => {
                    if (codeManualLiners.includes(liner)) {
                        return <InfoDiv title='Click on the icon to find your "Customer Code"'
                            onClick={() => {
                                window.open(`/pdf/CustomerCode/${liner}.pdf`)
                            }}
                        >{children}</InfoDiv>
                    }
                    else return children
                }

                return (
                    <Wrapper>
                        <input
                            type='text'
                            className={`fs--1 form-control ${error.customerCode ? 'is-invalid' : ''}`}
                            disabled={isDataTableDisabled || isFileUploading}
                            defaultValue={customerCode || ''}
                            maxLength={liner == 1 ? 8 : undefined}
                            onChange={(e) => {
                                //alert(LinerConfig[liner as keyof typeof LinerConfig])
                                if (LinerConfig[liner as keyof typeof LinerConfig]) {

                                    e.target.value = e.target.value.trim().replace(
                                        LinerConfig[liner as keyof typeof LinerConfig],
                                        ''
                                    );
                                }
                            }}
                            onBlur={(e) => {
                                dispatch(setPartnerTableRow(
                                    {
                                        rowNumber,
                                        customerCode: e.target.value,
                                        customerCodeErrorMessage: "",
                                    }
                                ))
                            }}
                        />

                        {customerCodeErrorMessage && (<div className="text-danger fs--2 mt-1"
                            style={{
                                fontSize: "0.95rem",
                                fontWeight: 600,
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                lineHeight: "1.3",
                                width: "100%",
                                minHeight: "1em",
                                boxSizing: "border-box",
                            }}
                        >
                            {customerCodeErrorMessage ? customerCodeErrorMessage : ""}
                        </div>)}
                    </Wrapper>
                );

            },
        },
        {
            accessor: 'attachmentName',
            Header: 'Invoice with Customer Code',
            width: 240,
            minWidth: 240,
            maxWidth: 290,
            Cell: (rowData: any) => {
                const { rowNumber, attachmentName, loading, customerCode, error } = rowData.row.original;
                // if (isDataTableDisabled || disableAttach) return <div className="h-100 d-flex align-items-center"><span
                //     className="fs--1"
                //     style={{ color: '#2c7be5', cursor: 'pointer' }}
                //     onClick={() => {
                //         window.open(`/api/user-management/v1/customer/openDocument?id=${encryptAndEncode(requestId)}&moduleTp=CUST_CODE_REQ&linerId=${encryptAndEncode(selectedLinerValues)}&customerCode=${encryptAndEncode(customerCode)}`)
                //     }}>{attachmentName}</span></div>
                return (
                    <UploadThing
                        name={attachmentName}
                        loading={loading}
                        labelWidth={'200px'}
                        invalid={error.attachment}
                        fileType={["PDF"]}
                        fileLimit={5}
                        disabled={isFileUploading}
                        clear={() => {
                            dispatch(setPartnerTableRow(
                                {
                                    rowNumber: rowNumber,
                                    attachmentName: '',
                                    serverPath: null,
                                    serverName: null,
                                    loading: 0
                                }
                            ))
                        }}
                        pending={(loading) => {
                            dispatch(setPartnerTableRow(
                                {
                                    rowNumber: rowNumber,
                                    loading: loading
                                }
                            ))

                        }}
                        fulfilled={(name, serverPath, serverName) => {
                            dispatch(setPartnerTableRow(
                                {
                                    rowNumber: rowNumber,
                                    attachmentName: name,
                                    serverPath: serverPath,
                                    serverName: serverName,
                                    loading: 100
                                }
                            ))
                        }}
                        selected={(name) => {
                            dispatch(setPartnerTableRow(
                                {
                                    rowNumber: rowNumber,
                                    attachmentName: name,
                                    loading: 0
                                }
                            ))
                        }}
                        failed={() => {
                            dispatch(setPartnerTableRow(
                                {
                                    rowNumber: rowNumber,
                                    loading: -1
                                }
                            ))
                        }}
                    />
                );
            },
        },
        {
            accessor: 'remove',
            Header: '',
            width: 20,
            minWidth: 20,
            maxWidth: 20,
            Cell: (rowData: any) => {
                const { remove, rowNumber } = rowData.row.original;
                if (!remove || isDataTableDisabled) return <></>
                return (
                    <Button
                        variant='falcon-warning'
                        style={{ background: 'transparent', border: 'none', boxShadow: 'none', padding: '0px' }}
                        disabled={isFileUploading}
                        onClick={() => {
                            const key = crypto.randomUUID()
                            if ( data.length < 2) {
                                dispatch(removePartnerTableRow({ rowNumber, key, m: true }))
                            } else {
                                dispatch(removePartnerTableRow({ rowNumber, key, m: false }))
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size='sm' />
                    </Button>
                );
            },
            disableSort: true,
        }
    ];

    return <div className='col-lg-12 mt-2 mb-2 demmurageTable d-flex flex-column'>

        {!isDataTableDisabled && <Button
            variant='falcon-primary'
            style={{
                width: '160px',
                marginRight: '10px',
                marginTop: '20px',
                marginBottom: '10px',
            }}
            size='sm'
            disabled={isFileUploading}
            onClick={() => {
                const rowNumber = crypto.randomUUID()
                dispatch(addPartnerTableRow({ key: rowNumber, m: true }))
            }}>
            <div className='d-flex'>
                <FontAwesomeIcon icon={faPlus} className='me-2 mt-1 ' />
                <span>Customer Code</span>
            </div>
        </Button>}

        <DataTable
            gridName='CUSTOMER_CODE_REQ_TABLE'
            columns={tableColumnConfig}
            data={data}
            perPage={100}
            sortable={true}
            searchable={false}
            showColumnFilter={false}
            selection={false}
            pagination={false}
            seekPagination={false}
            showExport={false}
            localFilter={true}
            uniqueFilterKey='customerCodeReqTable'
            autoHeight={true}
            maxHeight='200px'
            // tableMinHeight={300}
            staticHiddenCols={isDataTableDisabled ? ['rowNumber', "remove"] : ['rowNumber']}
        />
    </div>
}